import useJwt from '@/auth/jwt/useJwt'

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
// eslint-disable-next-line arrow-body-style
export const isUserLoggedIn = () => {
  return localStorage.getItem('user') && localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName)
}

export const getUser = () => JSON.parse(localStorage.getItem('user'))

/**
 * Girişten sonra dönülecek sayfa. Önceden yalnızca sayfa adı (ör. 'users.show') saklanıyordu; profil gibi
 * parametreli sayfalarda hangi profilin açılacağı kayboluyor, giriş sonrası yönlendirme hata veriyordu.
 * Artık tam adres saklanır; eski kayıtlardaki sayfa adları da desteklenir.
 */
export const saveLoginRedirect = route => {
  localStorage.setItem('loginRedirect', route.fullPath || route.path || route.name)
}

export const takeLoginRedirect = () => {
  const value = localStorage.getItem('loginRedirect')
  localStorage.removeItem('loginRedirect')
  if (!value) return null
  return value.startsWith('/') ? value : { name: value }
}

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
  if (userRole === 'admin') return '/'
  if (userRole === 'client') return { name: 'access-control' }
  return { name: 'auth-login' }
}
